import { Button, Modal } from 'rsuite';
import styled from 'styled-components';

export const PaddedModal = styled(Modal)`
  .rs-modal-content {
    padding: 0;
  }

  .rs-modal-header {
    display: flex;
    padding: 26px 30px;
  }

  .rs-modal-body {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    border-top: solid 1px rgba(0, 0, 0, 0.15);
    border-bottom: solid 1px rgba(0, 0, 0, 0.15);
  }

  .rs-modal-header-close {
    top: 26px;
    right: 26px;
  }

  .rs-modal-footer {
    padding: 15px 30px;
  }
`;

export const Tip = styled.div`
  text-align: right;
  width: 100%;
  margin-right: 30px;
  font-size: 14px;
  line-height: 1.57;
  color: rgba(0, 0, 0, 0.5);
`;

export const Close = styled(Button)`
  width: 100px;
  height: 36px;
  border-radius: 6px;
  margin-right: 12px;
  border: solid 1px #101938;
  color: #101938;
`;

export const Send = styled(Button)`
  width: ${(props) => (props.width ? props.width : '100px')};
  height: 36px;
  border-radius: 6px;
  color: white;
  background-color: #37a3bc;
`;

export * from '@/widgets/components/document-modal-styles';
